import { lazy } from 'react'
import { Navigate, useOutletContext, useParams, useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import { isSupplyAdmin, isSalesAdmin, isOperationAdmin, isLogisticsAdmin } from 'src/utils/adminFilter'

import paths from '../paths'
import { withSuspense } from './routeUtils'

import { enquiryStatus, auctionStatus, strings, MB_ROLES } from '@constants'
import DashboardLayout from '@global/DashboardLayout'

import AdminEnquiry from '@pages/Admin/Enquiry'
import AdminAuction from '@pages/Admin/Auction'
import AdminTools from '@pages/Admin/Tools'
import AdminContent from '@pages/Admin/Content'
import AdminReports from '@pages/Admin/Reports'
import AdminUnderwriting from '@pages/Admin/Underwriting'
import DuePayments from '@pages/Admin/PaymentSummary/DuePayments'
import Collections from '@pages/Admin/PaymentSummary/Collections'
// import LeadList from '@pages/Admin/OrgsAndUsers/Lead/LeadList'
// import Feedback from '@pages/Admin/OrgsAndUsers/Organisation/Financial/Feedback'
import SaleCollections from '@pages/Collections'
import CategoryInfo from '@pages/Admin/Catalog/CreateCategory/CategoryInfo'
// import OrgLeadList from '@pages/Admin/OrgsAndUsers/Organisation/OrgLeadList'
// import FinancialList from '@pages/Admin/OrgsAndUsers/Organisation/Financial/FinancialList'
import OrderEstimateForm from '@pages/Admin/OrderEstimate/OrderEstimateForm'
import DataCorrection from '@pages/Admin/Tools/DataCorrection'
import Glossary from '@pages/Admin/Content/Glossary'
import AddGlossary from '@pages/Admin/Content/Glossary/AddGlossary'
import Dashboard from '@pages/Admin/Dashboard/Dashboard'
import Maps from '@pages/Admin/Dashboard/Maps'
import OrgLocations from '@pages/Admin/Dashboard/OrgLocations'

// import DashboardReport from '@pages/Admin/Dashboard/DashboardReport'
import CompanyReport from '@pages/Admin/Dashboard/CompanyReport'
import PendingOrderReports from '@pages/Admin/Dashboard/DashboardReport/PendingOrderReports'
import OverallReport from '@pages/Admin/Dashboard/DashboardReport/OverallReport'
import CreateSPOV2 from '@pages/Admin/SalesPurchaseOrder2/CreateSPO/v2'
// import OrgProbe from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe'
// import ProbeCharges from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/ProbeCharges'
// import ProbeCompliance from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/ProbeCompliance'
// import ProbeShareholding from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/ProbeShareholding'
// import EnhancementTemplate from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/EnhancementTemplate'
// import ProbeFinancials from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/ProbeFinancials/index'
// import ManagementProbe from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/Management'
// import CompanyDetails from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/CompanyDetails'
import SalesPurchaseOrder2 from '@pages/Admin/SalesPurchaseOrder2'
import SPOListByStatus from '@pages/Admin/SalesPurchaseOrder2/SPOListByStatus'
import DispatchPlan from '@pages/Admin/DispatchPlan'
import DispatchPlanList from '@pages/Admin/DispatchPlan/DispatchPlanList'
import FetchFromProbeTool from '@pages/Admin/Tools/FetchFromProbe'
import AllDispatchPlans from '@pages/Admin/DispatchPlan/AllDispatchPlan'
import ShipmentList from '@pages/Admin/DispatchPlan/ShipmentList'
import FulfillmentList from '@pages/Admin/DispatchPlan/FulfillmentList'
// import CranReport from '@pages/Admin/OrgsAndUsers/Organisation/OrgProbe/CranReport'
import ReportsList from '@pages/Admin/DispatchPlan/ReportsList'
import TenderbookUserList from '@pages/Admin/Tenderbook/UserList'
import TenderBookLeadsList from '@pages/Admin/Tenderbook/TenderbookLeads'
import Tenderbook from '@pages/Admin/Tenderbook'
import TenderMaster from '@pages/Admin/Tenderbook/TenderMaster'
import SupperSale from '@pages/Admin/Dashboard/AdminSalesSupply/SupperSale'
import SupperSupply from '@pages/Admin/Dashboard/AdminSalesSupply/SupperSupply'
import DailyStandup from '@pages/Admin/Dashboard/DailyStandup'
import Leaderboard from '@pages/Admin/Dashboard/Leaderboard'
// import FeedbackSales from '@pages/Admin/OrgsAndUsers/Organisation/Financial/Feedback/Sales'
// import FeedbackSupply from '@pages/Admin/OrgsAndUsers/Organisation/Financial/Feedback/Supply'
// import FeedbackManagement from '@pages/Admin/OrgsAndUsers/Organisation/Financial/Feedback/Management'
// import FeedbackInspectionReport from '@pages/Admin/OrgsAndUsers/Organisation/Financial/Feedback/InspectionReport'
// import OrgLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger'
// import DashboardLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/Dashboard'
// import LedgerLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/Ledger'
// import OrderLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/Order'
// import EnquiryLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/Enquiry'
// import CollectionsLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/Collections'
// import CreditLimitLedger from '@pages/Admin/OrgsAndUsers/Organisation/Ledger/CreditLimit/index'
import Lead from '@pages/Admin/Lead'
import LeadListAll from '@pages/Admin/Lead/LeadList'
import PoInvoiceMapping from '@pages/Admin/Tools/PoInvoiceMapping'
import ReconciliationProcess from '@pages/Admin/Tools/ReconciliationProcess'
import UploadDashboardReport from '@pages/Admin/Tools/UploadDashboardReport'
import TenderBidderSearch from '@pages/Admin/Tenderbook/TenderBidderSearch'
import AdminLogisticsQuote from '@pages/Admin/LogisticsQuote'
import AdminLogisticsList from '@pages/Admin/LogisticsQuote/LogisticsList'
// import CreateAdminLogisticsQuote from '@pages/Admin/LogisticsQuote/CreateLogisticsQuote'
import LogisticsPrices from '@pages/Admin/LogisticsQuote/LogisticsPrices'
const ManageLead = lazy(() => import('@pages/Admin/Lead/ManageLead'))
const LeadDetails = lazy(() => import('@pages/Admin/Lead/ManageLead/LeadDetails'))
const EditLeadDetails = lazy(() => import('@pages/Admin/Lead/ManageLead/LeadDetails/EditLeadDetails'))
const InspectionLead = lazy(() => import('@pages/Admin/Lead/ManageLead/InspectionLead'))
const InspectionLeadList = lazy(() => import('@pages/Admin/Lead/ManageLead/InspectionLeadList'))
const NewInspectionLead = lazy(() => import('@pages/Admin/Lead/ManageLead/NewInspectionLead'))
const JourneyLead = lazy(() => import('@pages/Admin/Lead/ManageLead/Journey'))
const MeetingsLead = lazy(() => import('@pages/Admin/Lead/ManageLead/Meetings'))
const NotesLead = lazy(() => import('@pages/Admin/Lead/ManageLead/Notes'))
const TaskReminderLead = lazy(() => import('@pages/Admin/Lead/ManageLead/TaskReminder'))

// const LeadOrganisationDetail = lazy(() => import('@pages/Admin/OrgsAndUsers/Organisation/OrganisationLeadStage'))
const AdminDashboard = lazy(() => import(/* webpackChunkName: "AdminDashboard" */ '@pages/Admin/Dashboard'))
const Profile = lazy(() => import(/* webpackChunkName: "Profile" */ '@pages/Profile'))

// const OrgsAndUsers = lazy(() => import(/* webpackChunkName: "OrgsAndUsers" */ '@pages/Admin/OrgsAndUsers'))
const Organisations = lazy(() => import(/* webpackChunkName: "Organisations" */ '@pages/Admin/Organisations'))
// const OrganisationsList = lazy(() => import(/* webpackChunkName: "OrganisationsList" */ '@pages/Admin/OrgsAndUsers/Organisation/OrganisationsList'))
// const Organisation = lazy(() => import(/* webpackChunkName: "Organisation" */ '@pages/Admin/OrgsAndUsers/Organisation'))

export const OrganisationDetails = lazy(() =>
	import(/* webpackChunkName: "OrganisationDetails" */ '@pages/Admin/OrgsAndUsers/Organisation/OrganisationDetails')
)
export const OrganisationUsers = lazy(() =>
	import(/* webpackChunkName: "OrganisationUsers" */ '@pages/Admin/OrgsAndUsers/Organisation/OrganisationUsers')
)

export const OrganisationLedger = lazy(() =>
	import(/* webpackChunkName: "OrganisationLedger" */ '@pages/Admin/OrgsAndUsers/Organisation/OrganisationLedger')
)

export const OrganisationEditUser = lazy(() =>
	import(/* webpackChunkName: "OrganisationEditUser" */ '@pages/Admin/OrgsAndUsers/Organisation/OrganisationEditUser')
)

const UnderwritingV2 = lazy(() => import(/* webpackChunkName: "UnderwritingV2" */ '@pages/Admin/UnderwritingV2'))
const UnderwritingV2Inspection = lazy(() =>
	import(/* webpackChunkName: "UnderwritingV2Inspection" */ '@pages/Admin/UnderwritingV2/InspectionReports')
)
const UnderwritingV2Financial = lazy(() => import(/* webpackChunkName: "UnderwritingV2Financial" */ '@pages/Admin/UnderwritingV2/FinancialReports'))
const UnderwritingV2Cran = lazy(() => import(/* webpackChunkName: "UnderwritingV2Cran" */ '@pages/Admin/UnderwritingV2/Cran'))

const TenderbookUserDetails = lazy(() => import(/* webpackChunkName: "TenderbookUserDetails" */ '@pages/Admin/Tenderbook/UserList/UserDetails'))
const TenderbookUserBasicDetails = lazy(() =>
	import(/* webpackChunkName: "TenderbookUserBasicDetails" */ '@pages/Admin/Tenderbook/UserList/UserDetails/BasicDetails')
)
const TenderbookUserOverview = lazy(() =>
	import(/* webpackChunkName: "TenderbookUserOverview" */ '@pages/Admin/Tenderbook/UserList/UserDetails/Overview')
)
const TenderbookUserSubscription = lazy(() =>
	import(/* webpackChunkName: "TenderbookUserSubscription" */ '@pages/Admin/Tenderbook/UserList/UserDetails/Subscription')
)
const TenderbookUserTenderActivity = lazy(() =>
	import(/* webpackChunkName: "TenderbookUserTenderActivity" */ '@pages/Admin/Tenderbook/UserList/UserDetails/TenderActivity')
)
const TenderbookUserSearches = lazy(() =>
	import(/* webpackChunkName: "TenderbookUserSearches" */ '@pages/Admin/Tenderbook/UserList/UserDetails/Searches')
)

const OrganisationV2 = lazy(() => import(/* webpackChunkName: "OrganisationV2" */ '@pages/Admin/Organisations/Organisation'))
const OrganisationV2Details = lazy(() => import(/* webpackChunkName: "OrganisationV2Details" */ '@pages/Admin/Organisations/Organisation/Details'))
const OrganisationV2Mbook = lazy(() => import(/* webpackChunkName: "OrganisationV2Mbook" */ '@pages/Admin/Organisations/Organisation/Mbook'))
const OrganisationV2Underwriting = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2Underwriting" */ '@pages/Admin/Organisations/Organisation/Underwriting')
)
const OrganisationV2UnderwritingInspection = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2UnderwritingInspection" */ '@pages/Admin/Organisations/Organisation/Underwriting/InspectionReports')
)
const OrganisationV2UnderwritingFinancial = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2UnderwritingFinancial" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports')
)
const OrganisationV2UnderwritingCran = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2UnderwritingCran" */ '@pages/Admin/Organisations/Organisation/Underwriting/Cran')
)
const OrganisationV2InspectionReport = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2InspectionReport" */ '@pages/Admin/Organisations/Organisation/Underwriting/InspectionReports/InspectionReport'
	)
)
const OrganisationV2FinancialReport = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2FinancialReport" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report')
)
const OrganisationV2CranReport = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2CranReport" */ '@pages/Admin/Organisations/Organisation/Underwriting/Cran/CranReport')
)
const OrganisationV2ReportCompanyDetails = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportCompanyDetails" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/CompanyDetails'
	)
)
const OrganisationV2ReportManagement = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportManagement" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/Management'
	)
)
const OrganisationV2ReportFinancials = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportFinancials" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/ProbeFinancials'
	)
)
const OrganisationV2ReportConsolidated = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportConsolidated" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/ProbeConsolidated'
	)
)
const OrganisationV2ReportCharges = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportCharges" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/ProbeCharges'
	)
)
const OrganisationV2ReportCompliance = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportCompliance" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/ProbeCompliance'
	)
)
const OrganisationV2ReportShareholding = lazy(() =>
	import(
		/* webpackChunkName: "OrganisationV2ReportShareholding" */ '@pages/Admin/Organisations/Organisation/Underwriting/FinancialReports/Report/ProbeShareholding'
	)
)
const OrganisationV2EditUser = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2EditUser" */ '@pages/Admin/Organisations/Organisation/Details/Users/EditUser')
)
const OrganisationV2OrgDetails = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2OrgDetails" */ '@pages/Admin/Organisations/Organisation/Details/OrgDetails')
)
const OrganisationV2GstDetails = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2GstDetails" */ '@pages/Admin/Organisations/Organisation/Details/GstDetails')
)
const OrganisationV2SavedAddress = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2SavedAddress" */ '@pages/Admin/Organisations/Organisation/Details/SavedAddress')
)
const OrganisationV2Users = lazy(() => import(/* webpackChunkName: "OrganisationV2Users" */ '@pages/Admin/Organisations/Organisation/Details/Users'))
const OrganisationV2BasicFinancials = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2BasicFinancials" */ '@pages/Admin/Organisations/Organisation/Details/BasicFinancials')
)
const OrganisationV2MbookDashboard = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookDashboard" */ '@pages/Admin/Organisations/Organisation/Mbook/Dashboard')
)
const OrganisationV2MbookEnquiry = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookEnquiry" */ '@pages/Admin/Organisations/Organisation/Mbook/Enquiry')
)
const OrganisationV2MbookOrder = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookOrder" */ '@pages/Admin/Organisations/Organisation/Mbook/Order')
)
const OrganisationV2MbookLedger = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookLedger" */ '@pages/Admin/Organisations/Organisation/Mbook/Ledger')
)
const OrganisationV2MbookCollections = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookCollections" */ '@pages/Admin/Organisations/Organisation/Mbook/Collections')
)
const OrganisationV2MbookCreditLimit = lazy(() =>
	import(/* webpackChunkName: "OrganisationV2MbookCreditLimit" */ '@pages/Admin/Organisations/Organisation/Mbook/CreditLimit')
)

const Admins = lazy(() => import(/* webpackChunkName: "Admins" */ '@pages/Admin/Admins'))
const AdminsList = lazy(() => import(/* webpackChunkName: "AdminsList" */ '@pages/Admin/OrgsAndUsers/AdminUsers/AdminsList'))
const PastRecords = lazy(() => import(/* webpackChunkName: "PastRecords" */ '@pages/Admin/PaymentSummary/PastRecords'))
const Unregistered = lazy(() => import(/* webpackChunkName: "Unregistered" */ '@pages/Admin/OrgsAndUsers/Unregistered'))
// const UserList = lazy(() => import(/* webpackChunkName: "Unregistered" */ '@pages/Admin/OrgsAndUsers/UserList'))
const CatalogMain = lazy(() => import(/* webpackChunkName: "CatalogMain" */ '@pages/Admin/Catalog'))
const CategoryList = lazy(() => import(/* webpackChunkName: "CategoryList" */ '@pages/Admin/Catalog/CategoryList'))
const ProductList = lazy(() => import(/* webpackChunkName: "ProductList" */ '@pages/Admin/Catalog/ProductList'))
const BrandList = lazy(() => import(/* webpackChunkName: "BrandList" */ '@pages/Admin/Catalog/BrandList'))
const Commodity = lazy(() => import(/* webpackChunkName: "Commodity" */ '@pages/Admin/Catalog/Commodity'))
const AdminManageEnquiries = lazy(() => import(/* webpackChunkName: "AdminManageEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries'))
const AdminOrders = lazy(() => import(/* webpackChunkName: "AdminOrders" */ '@pages/Admin/Orders'))
const AdminOrdersByStatus = lazy(() => import(/* webpackChunkName: "AdminOrdersByStatus" */ '@pages/Admin/Orders/OrderByStatus'))
const AdminOrdersActiveInvoice = lazy(() => import(/* webpackChunkName: "AdminOrdersActiveInvoice" */ '@pages/Admin/Orders/ActiveInvoice'))
const AdminOrdersOrderBook = lazy(() => import(/* webpackChunkName: "AdminOrdersActiveInvoice" */ '@pages/Admin/Orders/OrderBook'))
const AdminOrdersPendingDispatch = lazy(() =>
	import(/* webpackChunkName: "AdminOrdersPendingDispatch" */ '@pages/Admin/Orders/PendingDispatch')
)
const AdminOrdersActiveTrip = lazy(() => import(/* webpackChunkName: "AdminOrdersActiveTrip" */ '@pages/Admin/Orders/ActiveTrip'))
const AdminManageOrder = lazy(() => import(/* webpackChunkName: "AdminManageOrder" */ '@pages/Admin/Orders/ManageOrder'))
const AdminAuctionOrders = lazy(() => import(/* webpackChunkName: "AdminAuctionOrders" */ '@pages/Admin/AuctionOrders'))
const AdminAuctionOrdersByStatus = lazy(() => import(/* webpackChunkName: "AdminAuctionOrdersByStatus" */ '@pages/Admin/AuctionOrders/OrderByStatus'))
const AdminManageAuctionOrder = lazy(() => import(/* webpackChunkName: "AdminManageAuctionOrder" */ '@pages/Admin/AuctionOrders/ManageOrder'))
const AdminPaymentSummary = lazy(() => import(/* webpackChunkName: "AdminPaymentSummary" */ '@pages/Admin/PaymentSummary'))
const Ledgers = lazy(() => import(/* webpackChunkName: "Ledgers" */ '@pages/Admin/PaymentSummary/Ledgers'))
const Payment = lazy(() => import(/* webpackChunkName: "Payment" */ '@pages/Admin/PaymentSummary/Payment'))
const SaleInvoices = lazy(() => import(/* webpackChunkName: "SaleInvoices" */ '@pages/Admin/PaymentSummary/SaleInvoices'))
const PurchaseInvoices = lazy(() => import(/* webpackChunkName: "PurchaseInvoices" */ '@pages/Admin/PaymentSummary/PurchaseInvoices'))
const Inventory = lazy(() => import(/* webpackChunkName: "Inventory" */ '@pages/Admin/Inventory/index'))

export const AdminCreateEnquiry = lazy(() => import(/* webpackChunkName: "AdminCreateEnquiry" */ '@pages/Admin/Enquiry/CreateEnquiry'))
const AdminAssignEnquiry = lazy(() => import(/* webpackChunkName: "AdminAssignEnquiry" */ '@pages/Admin/Enquiry/ManageEnquiries/AssignEnquiry'))
const AdminEditEnquiry = lazy(() => import(/* webpackChunkName: "AdminEditEnquiry" */ '@pages/Admin/Enquiry/ManageEnquiries/EditEnquiry'))
const AdminAllEnquiries = lazy(() => import(/* webpackChunkName: "AdminAllEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries/AllEnquiries'))
const AdminVerifyEnquiry = lazy(() => import(/* webpackChunkName: "AdminVerifyEnquiry" */ '@pages/Admin/Enquiry/ManageEnquiries/VerifyEnquiry'))
const AdminActiveEnquiries = lazy(() => import(/* webpackChunkName: "AdminActiveEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries/ActiveEnquiries'))
const AdminMyEnquiries = lazy(() => import(/* webpackChunkName: "AdminMyEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries/MyEnquiries'))
const AdminSubmitQuoteEnquiries = lazy(() =>
	import(/* webpackChunkName: "AdminSubmitQuoteEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries/SubmitQuoteEnquiries')
)
const AdminActiveQuoteEnquiries = lazy(() =>
	import(/* webpackChunkName: "AdminActiveQuoteEnquiries" */ '@pages/Admin/Enquiry/ManageEnquiries/ActiveQuoteEnquiries')
)
const AdminManageEnquiry = lazy(() => import(/* webpackChunkName: "AdminManageEnquiry" */ '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry'))
const ViewEnquiryDetails = lazy(() =>
	import(/* webpackChunkName: "ViewEnquiryDetails" */ '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/ViewEnquiryDetails')
)
const SupplierQuotesV2 = lazy(() =>
	import(/* webpackChunkName: "SupplierQuotesV2" */ '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/SupplierQuotes/SupplierQuotesV2')
)
const EditBuyerQuotesV2 = lazy(() =>
	import(/* webpackChunkName: "EditBuyerQuotesV2" */ '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/EditBuyerQuotes/EditBuyerQuotesV2')
)

const AdminCreateAuction = lazy(() => import(/* webpackChunkName: "AdminCreateAuction" */ '@pages/Admin/Auction/CreateAuction'))
const AdminEditAuction = lazy(() => import(/* webpackChunkName: "AdminEditAuction" */ '@pages/Admin/Auction/ManageAuctions/EditAuction'))
const AdminViewAuction = lazy(() => import(/* webpackChunkName: "AdminViewAuction" */ '@pages/Admin/Auction/ManageAuctions/ViewAuction'))
const AdminManageAuction = lazy(() => import(/* webpackChunkName: "AdminManageAuction" */ '@pages/Admin/Auction/ManageAuctions/ManageAuction'))

const AdminManageAuctions = lazy(() => import(/* webpackChunkName: "AdminManageAuctions" */ '@pages/Admin/Auction/ManageAuctions'))
const AdminAssignAuction = lazy(() => import(/* webpackChunkName: "AdminAssignAuction" */ '@pages/Admin/Auction/ManageAuctions/AssignAuction'))
const AdminAllAuctions = lazy(() => import(/* webpackChunkName: "AdminAllAuctions" */ '@pages/Admin/Auction/ManageAuctions/AllAuctions'))
const AdminVerifyAuction = lazy(() => import(/* webpackChunkName: "AdminVerifyAuction" */ '@pages/Admin/Auction/ManageAuctions/VerifyAuction'))
const AdminActiveAuctions = lazy(() => import(/* webpackChunkName: "AdminActiveAuctions" */ '@pages/Admin/Auction/ManageAuctions/ActiveAuctions'))
const AdminMyAuctions = lazy(() => import(/* webpackChunkName: "AdminMyAuctions" */ '@pages/Admin/Auction/ManageAuctions/MyAuctions'))

const AdminCloudFactory = lazy(() => import(/* webpackChunkName: "AdminCloudFactory" */ '@pages/Admin/CloudFactory'))
const AdminListFactories = lazy(() => import(/* webpackChunkName: "AdminListFactories" */ '@pages/Admin/CloudFactory/ListFactories'))
const AdminListMachines = lazy(() => import(/* webpackChunkName: "AdminListMachines" */ '@pages/Admin/CloudFactory/ListMachines'))
const AdminCreateFactory = lazy(() => import(/* webpackChunkName: "AdminCreateFactory" */ '@pages/Admin/CloudFactory/CreateFactory'))
const AdminCreateMachine = lazy(() => import(/* webpackChunkName: "AdminCreateMachine" */ '@pages/Admin/CloudFactory/CreateMachine'))
const AdminEditMachine = lazy(() => import(/* webpackChunkName: "AdminEditMachine" */ '@pages/Admin/CloudFactory/EditMachine'))
const AdminEditFactory = lazy(() => import(/* webpackChunkName: "AdminEditFactory" */ '@pages/Admin/CloudFactory/EditFactory'))
const AdminListFactoryOrders = lazy(() => import(/* webpackChunkName: "AdminListFactoryOrders" */ '@pages/Admin/CloudFactory/Orders/ListOrders'))
export const AdminCreateFactoryOrder = lazy(() =>
	import(/* webpackChunkName: "AdminCreateFactoryOrder" */ '@pages/Admin/CloudFactory/Orders/CreateOrder')
)
const AdminManageCloudOrder = lazy(() => import(/* webpackChunkName: "AdminManageCloudOrder" */ '@pages/Admin/CloudFactory/Orders/ManageOrder'))

const AdminAllTools = lazy(() => import(/* webpackChunkName: "AdminAllTools" */ '@pages/Admin/Tools/AllTools'))
const AdminEndorsement = lazy(() => import(/* webpackChunkName: "AdminEndorsement" */ '@pages/Admin/Tools/TCEndorsement'))
const AdminInvoiceEndorsement = lazy(() => import(/* webpackChunkName: "AdminInvoiceEndorsement" */ '@pages/Admin/Tools/InvoiceEndorsement'))
const AdminLogisticCalculator = lazy(() => import(/* webpackChunkName: "AdminLogisticCalculator" */ '@pages/Admin/Tools/LogisticCalculator'))
const AdminDistanceCalculator = lazy(() => import(/* webpackChunkName: "AdminDistanceCalculator" */ '@pages/Admin/Tools/DistanceCalculator'))
const AdminVernacularize = lazy(() => import(/* webpackChunkName: "AdminVernacularize" */ '@pages/Admin/Tools/VernacularizeText'))
const AdminToolsIFC = lazy(() => import(/* webpackChunkName: "AdminToolsIFC" */ '@pages/Admin/Tools/AdminToolsIFC'))
const WeightCalculator = lazy(() => import(/* webpackChunkName: "WeightCalculator" */ '@pages/Admin/Tools/WeightCalculator'))

const AdminBanner = lazy(() => import(/* webpackChunkName: "AdminBanner" */ '@pages/Admin/Content/Banner'))
const AdminAllContent = lazy(() => import(/* webpackChunkName: "AdminAllContent" */ '@pages/Admin/Content/AllContents'))
const Blog = lazy(() => import(/* webpackChunkName: "Blog" */ '@pages/Admin/Content/Blog'))
const CreateBlog = lazy(() => import(/* webpackChunkName: "CreateBlog" */ '@pages/Admin/Content/Blog/CreateBlog'))
const News = lazy(() => import(/* webpackChunkName: "News" */ '@pages/Admin/Content/News'))

const AdminAllReports = lazy(() => import(/* webpackChunkName: "AdminAllReports" */ '@pages/Admin/Reports/AllReports'))
const ViewReport = lazy(() => import(/* webpackChunkName: "ViewReport" */ '@pages/Admin/Reports/ViewReport'))

const ApprovalMetrics = lazy(() => import(/* webpackChunkName: "ApprovalMetrics" */ '@pages/Admin/ApprovalMetrics'))
const ListApprovalMetrics = lazy(() => import(/* webpackChunkName: "ListApprovalMetrics" */ '@pages/Admin/ApprovalMetrics/ListApprovalMetrics'))

const CommodityPrices = lazy(() => import(/* webpackChunkName: "CommodityPrices" */ '@pages/Admin/CommodityPrices'))
const AdminInvoice = lazy(() => import(/* webpackChunkName: "AdminInvoice" */ '@pages/Admin/Invoice'))

const AllUnderwriting = lazy(() => import(/* webpackChunkName: "AllUnderwriting" */ '@pages/Admin/Underwriting/AllUnderwriting'))
const ViewUnderwritingReport = lazy(() => import(/* webpackChunkName: "ViewUnderwritingReport" */ '@pages/Admin/Underwriting/ViewReport'))
const UnderwritingCranList = lazy(() => import(/* webpackChunkName: "AllUnderwriting" */ '@pages/Admin/Underwriting/AllUnderwriting/CranList'))

const MBDocuments = lazy(() => import(/* webpackChunkName: "MBDocuments" */ '@pages/Admin/MBDocuments'))
export const AdminOrderEstimate = lazy(() => import(/* webpackChunkName: "AdminOrderEstimate" */ '@pages/Admin/OrderEstimate'))

const AdminBuyerOrderDetails = lazy(() =>
	import(/* webpackChunkName: "AdminBuyerOrderDetails" */ '@pages/Admin/Orders/ManageOrder/BuyerOrderDetails')
)
const Suppliers = lazy(() => import(/* webpackChunkName: "Suppliers" */ '@pages/Admin/Orders/ManageOrder/Suppliers'))
const PreviewPO = lazy(() => import(/* webpackChunkName: "PreviewPO" */ '@pages/Admin/Enquiry/ManageEnquiries/ManageEnquiry/PreviewPO'))
const EditDispatchPlan = lazy(() => import(/* webpackChunkName: "EditDispatchPlan" */ '@pages/Admin/DispatchPlan/EditDispatchPlan'))
const AddDispatchPlanV2 = lazy(() => import(/* webpackChunkName: "AddDispatchPlanV2" */ '@pages/Admin/DispatchPlan/AddDispatchPlanV2'))
const OrderDispatchPlans = lazy(() => import(/* webpackChunkName: "OrderDispatchPlans" */ '@pages/Admin/Orders/ManageOrder/DispatchPlans'))
const LogisticsQuote = lazy(() => import(/* webpackChunkName: "LogisticsQuote" */ '@pages/Admin/LogisticsQuoteV2'))
const OrderShipment = lazy(() => import(/* webpackChunkName: "OrderShipment" */ '@pages/Admin/Orders/ManageOrder/Shipment'))
const CreateShipment = lazy(() =>
	import(/* webpackChunkName: "CreateShipment" */ '@pages/Admin/Orders/ManageOrder/Shipment/CreateShipment')
)
const EditShipment = lazy(() => import(/* webpackChunkName: "EditShipment" */ '@pages/Admin/Orders/ManageOrder/Shipment/EditShipment'))
const CreateFulfillment = lazy(() =>
	import(/* webpackChunkName: "CreateFulfillment" */ '@pages/Admin/Orders/ManageOrder/Shipment/Fulfillment/CreateFulfillment')
)
const EditFulfillment = lazy(() =>
	import(/* webpackChunkName: "EditFulfillment" */ '@pages/Admin/Orders/ManageOrder/Shipment/Fulfillment/EditFulfillment')
)
const FulfillmentPlans = lazy(() =>
	import(/* webpackChunkName: "FulfillmentPlans" */ '@pages/Admin/Orders/ManageOrder/Shipment/Fulfillment/FulfillmentPlans')
)

const EditOrderIndexRedirect = () => {
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const { orderId } = useParams()
	const location = useLocation()
	if (isSupplyAdmin(user?.role, false)) {
		return <Navigate to={paths.admin_manage_enquiry_order_edit_suppliers(orderId) + location.search} replace />
	}
	return <Navigate to={paths.admin_manage_enquiry_order_edit_details(orderId) + location.search} replace />
}

// The standalone "view enquiry" page is gone — everything opens on the Manage page, which decides
// what is editable. Old /view/:enquiryId links keep working through this redirect.
const ViewEnquiryRedirect = () => {
	const { enquiryId } = useParams()
	const location = useLocation()
	return <Navigate to={paths.admin_manage_enquiry_manage(enquiryId) + location.search} replace />
}

const OrderDetailsRoute = () => {
	const { order, update, buyerOrderUpdateRef } = useOutletContext()
	return <AdminBuyerOrderDetails order={order} update={update} buyerOrderUpdateRef={buyerOrderUpdateRef} />
}

const OrderSuppliersRoute = () => {
	const { order, update, setShowSlidableComponent } = useOutletContext()
	return <Suppliers order={order} update={update} setShowSlidableComponent={setShowSlidableComponent} />
}

const OrderPreviewPORoute = () => {
	const { order, update, setHeaderActions } = useOutletContext()
	return <PreviewPO order={order} update={update} setHeaderActions={setHeaderActions} />
}

const OrderDispatchPlansRoute = () => {
	const { order, update } = useOutletContext()
	return <OrderDispatchPlans order={order} update={update} />
}

const OrderLogisticsQuoteRoute = () => {
	const { order, update, setShowSlidableComponent } = useOutletContext()
	return <LogisticsQuote entity={order} variant='ORDER' update={update} setShowSlidableComponent={setShowSlidableComponent} />
}

const ManageEnquiryIndexRedirect = () => {
	const { enquiryId } = useParams()
	const location = useLocation()
	return <Navigate to={paths.admin_manage_enquiry_manage_details(enquiryId) + location.search} replace />
}

const EnquiryDetailsRoute = () => {
	const { goToTab, enquiry, update } = useOutletContext()
	return <ViewEnquiryDetails goToTab={goToTab} inManageRoute enquiry={enquiry} update={update} />
}

const EnquirySupplierQuotesRoute = () => {
	const { goToTab, enquiry, setShowSlidableComponent, enquiryById, update } = useOutletContext()
	return (
		<SupplierQuotesV2
			goToTab={goToTab}
			inManageRoute
			enquiry={enquiry}
			setShowSlidableComponent={setShowSlidableComponent}
			enquiryById={enquiryById}
			update={update}
		/>
	)
}

const EnquiryBuyerQuotesRoute = () => {
	const { enquiryId } = useParams()
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const { goToTab, enquiry, update, pastDelays, selectRetailSupplier } = useOutletContext()
	if (!(isSalesAdmin(user?.role) || isOperationAdmin(user?.role) || isLogisticsAdmin(user?.role))) {
		return <Navigate to={paths.admin_manage_enquiry_manage_details(enquiryId)} replace />
	}
	return (
		<EditBuyerQuotesV2
			goToTab={goToTab}
			enquiry={enquiry}
			update={update}
			pastDelays={pastDelays}
			selectedRetailSupplier={selectRetailSupplier}
		/>
	)
}

const EnquiryLogisticsQuoteRoute = () => {
	const { enquiry, update, setShowSlidableComponent } = useOutletContext()
	return <LogisticsQuote entity={enquiry} variant='ENQUIRY' update={update} setShowSlidableComponent={setShowSlidableComponent} />
}

const EnquiryPreviewPORoute = () => {
	const { enquiryId } = useParams()
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const { goToTab, enquiry, update, pastDelays, setHeaderActions } = useOutletContext()
	if (!(isSalesAdmin(user?.role) || isSupplyAdmin(user?.role) || isOperationAdmin(user?.role))) {
		return <Navigate to={paths.admin_manage_enquiry_manage_details(enquiryId)} replace />
	}
	return <PreviewPO enquiry={enquiry} update={update} goToTab={goToTab} pastDelays={pastDelays} setHeaderActions={setHeaderActions} />
}

const AdminRoutes = {
	path: paths.admin,
	element: <DashboardLayout />,
	protected: true,
	children: [
		{ index: true, element: <Navigate to={paths.admin_dashboard} /> },
		{
			path: paths.routePath(paths.admin_dashboard, paths.admin),
			element: withSuspense(<AdminDashboard />),
			title: strings('dashboard'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_dashboard_all} /> },
				{
					path: paths.admin_dashboard_all,
					element: withSuspense(<Dashboard />),
				},
				{
					path: paths.admin_dashboard_sales,
					element: withSuspense(<SupperSale dashboardType={MB_ROLES.SALES} />),
				},
				{
					path: paths.admin_dashboard_supply,
					element: withSuspense(<SupperSupply dashboardType={MB_ROLES.SUPPLY} />),
				},
				{
					path: paths.admin_dashboard_map,
					element: withSuspense(<Maps />),
				},

				{
					path: paths.admin_dashboard_manufacturer,
					element: withSuspense(<OrgLocations />),
				},

				{
					path: paths.admin_dashboard_reports,
					element: withSuspense(<DailyStandup />),
					// children: [{ index: true, element: <Navigate to={paths.admin_dashboard_reports} /> }],
				},
				{
					path: paths.admin_dashboard_overall,
					element: withSuspense(<CompanyReport />),
				},
				{
					path: paths.admin_dashboard_target,
					element: withSuspense(<OverallReport />),
				},
				{
					path: paths.admin_dashboard_pending_order,
					element: withSuspense(<PendingOrderReports />),
				},
				{
					path: paths.admin_dashboard_leaderboard,
					element: withSuspense(<Leaderboard />),
				},
				// {
				// 	path: paths.admin_dashboard_daily_standup,
				// 	element: withSuspense(<DailyStandup />),
				// },
			],
		},
		{ path: paths.routePath(paths.admin_profile, paths.admin), element: withSuspense(<Profile />), title: strings('my_profile') },
		{
			path: paths.routePath(paths.admin_organisations, paths.admin),
			element: withSuspense(<Organisations />),
			title: strings('organisations'),
		},
		{
			path: paths.routePath(paths.admin_organisations_view(), paths.admin),
			element: withSuspense(<OrganisationV2 />),
			children: [
				{
					path: paths.admin_organisations_details(),
					element: withSuspense(<OrganisationV2Details admin />),
					children: [
						{
							path: paths.admin_organisations_details_org(),
							element: withSuspense(<OrganisationV2OrgDetails admin />),
						},
						{
							path: paths.admin_organisations_details_gst(),
							element: withSuspense(<OrganisationV2GstDetails admin />),
						},
						{
							path: paths.admin_organisations_details_address(),
							element: withSuspense(<OrganisationV2SavedAddress admin />),
						},
						{
							path: paths.admin_organisations_details_users(),
							element: withSuspense(<OrganisationV2Users admin />),
						},
						{
							path: paths.admin_organisations_details_financials(),
							element: withSuspense(<OrganisationV2BasicFinancials admin />),
						},
					],
				},
				{
					path: paths.admin_organisations_mbook(),
					element: withSuspense(<OrganisationV2Mbook admin />),
					children: [
						{
							path: paths.admin_organisations_mbook_dashboard(),
							element: withSuspense(<OrganisationV2MbookDashboard admin />),
						},
						{
							path: paths.admin_organisations_mbook_enquiry(),
							element: withSuspense(<OrganisationV2MbookEnquiry admin />),
						},
						{
							path: paths.admin_organisations_mbook_order(),
							element: withSuspense(<OrganisationV2MbookOrder admin />),
						},
						{
							path: paths.admin_organisations_mbook_ledger(),
							element: withSuspense(<OrganisationV2MbookLedger admin />),
						},
						{
							path: paths.admin_organisations_mbook_collections(),
							element: withSuspense(<OrganisationV2MbookCollections admin />),
						},
						{
							path: paths.admin_organisations_mbook_credit_limit(),
							element: withSuspense(<OrganisationV2MbookCreditLimit admin />),
						},
					],
				},
				{
					path: paths.admin_organisations_underwriting(),
					element: withSuspense(<OrganisationV2Underwriting admin />),
					children: [
						{
							path: paths.admin_organisations_underwriting_inspection(),
							element: withSuspense(<OrganisationV2UnderwritingInspection admin />),
						},
						{
							path: paths.admin_organisations_underwriting_financial(),
							element: withSuspense(<OrganisationV2UnderwritingFinancial admin />),
						},
						{
							path: paths.admin_organisations_underwriting_cran(),
							element: withSuspense(<OrganisationV2UnderwritingCran admin />),
						},
						{
							path: paths.admin_organisations_cran_report(),
							element: withSuspense(<OrganisationV2CranReport admin />),
						},
						{
							path: paths.admin_organisations_underwriting_cran_by_id(),
							element: withSuspense(<OrganisationV2CranReport admin />),
						},
						{
							path: paths.admin_organisations_underwriting_inspection_report(),
							element: withSuspense(<OrganisationV2InspectionReport admin />),
						},
						{
							// The probe report's id lives in the path, so every tab below keeps it and can send
							// it to its own API.
							path: `${paths.admin_organisations_financial_report()}/:probeId`,
							element: withSuspense(<OrganisationV2FinancialReport admin />),
							children: [
								{ index: true, element: <Navigate to='company-details' replace /> },
								{ path: 'company-details', element: withSuspense(<OrganisationV2ReportCompanyDetails />) },
								{ path: 'management', element: withSuspense(<OrganisationV2ReportManagement />) },
								{ path: 'financials', element: withSuspense(<OrganisationV2ReportFinancials />) },
								{ path: 'consolidated', element: withSuspense(<OrganisationV2ReportConsolidated />) },
								{ path: 'charges', element: withSuspense(<OrganisationV2ReportCharges />) },
								{ path: 'compliance', element: withSuspense(<OrganisationV2ReportCompliance />) },
								{ path: 'shareholding', element: withSuspense(<OrganisationV2ReportShareholding />) },
								{ path: '*', element: <Navigate to='company-details' replace /> },
							],
						},
					],
				},
			],
		},
		{
			path: paths.routePath(paths.admin_organisations_edit_user(), paths.admin),
			element: withSuspense(<OrganisationV2EditUser admin />),
		},
		{
			path: paths.routePath(paths.admin_admins, paths.admin),
			element: withSuspense(<Admins />),
			title: strings('admins'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_view_admins} replace /> },
				{ path: paths.admin_view_admins, element: withSuspense(<AdminsList isAdmin />) },
				{ path: paths.admin_unregistered, element: withSuspense(<Unregistered isAdmin />) },
				{ path: paths.admin_edit_user(), element: withSuspense(<Profile isAdmin />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_view_admins} replace />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_catalog, paths.admin),
			element: withSuspense(<CatalogMain />),
			title: strings('catalog'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_catalog_categories} /> },
				{
					path: paths.admin_catalog_categories,
					element: withSuspense(<CategoryList sourceFilter='CRM' />),
				},
				{
					path: paths.admin_catalog_edit_category(),
					element: withSuspense(<CategoryInfo />),
				},
				{
					path: paths.admin_catalog_products,
					element: withSuspense(<ProductList />),
				},
				{
					path: paths.admin_catalog_brands,
					element: withSuspense(<BrandList />),
				},
				{
					path: paths.admin_catalog_commodity,
					element: withSuspense(<Commodity />),
				},
				{
					path: paths.admin_catalog_website_categories,
					element: withSuspense(<CategoryList sourceFilter='WEBSITE' />),
				},

				{
					path: '*',
					element: <Navigate to={paths.admin_catalog_categories} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_enquiry, paths.admin),
			element: <AdminEnquiry />,
			children: [
				{ index: true, element: <Navigate to={paths.admin_create_enquiry} /> },
				{ path: paths.admin_create_enquiry, element: withSuspense(<AdminCreateEnquiry />), title: strings('create_enquiry') },
				{
					path: paths.admin_punch_order,
					element: withSuspense(<AdminOrderEstimate />),
					title: strings('punch_order'),
				},
				{ path: paths.admin_punch_order_create, element: withSuspense(<OrderEstimateForm />), title: strings(['create', 'punch_order']) },
				{ path: paths.admin_punch_order_view(), element: withSuspense(<OrderEstimateForm isView />), title: strings('punch_order') },
				{
					path: paths.admin_manage_enquiry,
					element: withSuspense(<AdminManageEnquiries />),
					title: strings('manage_enquiries'),
					children: [
						{ index: true, element: <Navigate to={paths.admin_manage_enquiry_active} /> },
						{ path: paths.admin_manage_enquiry_assign, element: withSuspense(<AdminAssignEnquiry status={[enquiryStatus.created]} />) },
						{ path: paths.admin_manage_enquiry_all, element: withSuspense(<AdminAllEnquiries />) },
						{ path: paths.admin_manage_enquiry_verify, element: withSuspense(<AdminVerifyEnquiry status={enquiryStatus.unverified} />) },
						{ path: paths.admin_manage_enquiry_active, element: withSuspense(<AdminActiveEnquiries status={enquiryStatus.active} />) },
						{ path: paths.admin_manage_enquiry_my, element: withSuspense(<AdminMyEnquiries />) },
						{
							path: paths.admin_manage_enquiry_submit_quote,
							element: withSuspense(<AdminSubmitQuoteEnquiries status={enquiryStatus.active} />),
						},
						{
							path: paths.admin_manage_enquiry_active_quote,
							element: withSuspense(<AdminActiveQuoteEnquiries status={enquiryStatus.active} active={true} />),
						},
						{
							path: paths.admin_manage_enquiry_all_quote,
							element: withSuspense(<AdminActiveQuoteEnquiries status={enquiryStatus.active} active={false} />),
						},
						{ path: paths.admin_manage_enquiry_view(), element: <ViewEnquiryRedirect /> },
						{ path: paths.admin_manage_enquiry_edit(), element: withSuspense(<AdminEditEnquiry />) },
						{
							path: paths.admin_manage_enquiry_manage(),
							element: withSuspense(<AdminManageEnquiry />),
							children: [
								{ index: true, element: <ManageEnquiryIndexRedirect /> },
								{ path: paths.admin_manage_enquiry_manage_details(), element: withSuspense(<EnquiryDetailsRoute />) },
								{
									path: paths.admin_manage_enquiry_manage_supplier_quotes(),
									element: withSuspense(<EnquirySupplierQuotesRoute />),
								},
								{ path: paths.admin_manage_enquiry_manage_buyer_quotes(), element: withSuspense(<EnquiryBuyerQuotesRoute />) },
								{
									path: paths.admin_manage_enquiry_manage_logistics_quote(),
									element: withSuspense(<EnquiryLogisticsQuoteRoute />),
								},
								{ path: paths.admin_manage_enquiry_manage_preview_po(), element: withSuspense(<EnquiryPreviewPORoute />) },
							],
						},
						{ path: paths.admin_manage_enquiry_all_create_order, element: withSuspense(<AdminAllEnquiries fetchForOperation />) },
						{
							path: '*',
							element: <Navigate to={paths.admin_manage_enquiry_all} />,
						},
					],
				},
			],
		},
		{
			path: paths.routePath(paths.admin_spo, paths.admin),
			element: withSuspense(<SalesPurchaseOrder2 />),
			title: strings(['manage', 'spo']),
			children: [
				{ index: true, element: <Navigate to={paths.admin_create_spo} /> },
				{ path: paths.admin_create_spo, element: withSuspense(<CreateSPOV2 />), title: strings(['create', 'spo']) },
				{ path: paths.admin_edit_spo(), element: withSuspense(<CreateSPOV2 />), title: strings(['edit', 'spo']) },
				{
					path: '*',
					element: <Navigate to={paths.admin_create_spo} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_manage_spo, paths.admin),
			element: withSuspense(<SalesPurchaseOrder2 />),
			title: strings(['manage', 'spo']),
			children: [
				{ index: true, element: <Navigate to={paths.admin_manage_spo_status('all')} /> },
				{ path: paths.admin_manage_spo_status(), element: withSuspense(<SPOListByStatus />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_manage_spo_status('all')} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_manage_enquiry_orders, paths.admin),
			element: withSuspense(<AdminOrders />),
			title: strings('manage_enquiry_orders'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_manage_enquiry_order_status('active')} /> },
				{
					path: paths.admin_manage_enquiry_order_status(),
					element: withSuspense(<AdminOrdersByStatus isEnquiryOrders />),
				},
				{
					path: paths.admin_manage_enquiry_orders_pending_dispatch,
					element: withSuspense(<AdminOrdersPendingDispatch />),
				},
				{
					path: paths.admin_manage_enquiry_orders_active_invoice,
					element: withSuspense(<AdminOrdersActiveInvoice />),
				},
				{
					path: paths.admin_manage_enquiry_orders_active_trip,
					element: withSuspense(<AdminOrdersActiveTrip />),
				},
				{
					path: paths.admin_manage_enquiry_order_edit(),
					element: withSuspense(<AdminManageOrder />),
					children: [
						{ index: true, element: <EditOrderIndexRedirect /> },
						{
							path: paths.admin_manage_enquiry_order_edit_details(),
							element: withSuspense(<OrderDetailsRoute />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_suppliers(),
							element: withSuspense(<OrderSuppliersRoute />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_preview_po(),
							element: withSuspense(<OrderPreviewPORoute />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_dispatch_plans(),
							element: withSuspense(<OrderDispatchPlansRoute />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_dispatch_plans_create(),
							element: withSuspense(<AddDispatchPlanV2 />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_dispatch_plans_edit(),
							element: withSuspense(<EditDispatchPlan />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_logistics_quote(),
							element: withSuspense(<OrderLogisticsQuoteRoute />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment(),
							element: withSuspense(<OrderShipment />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment_create(),
							element: withSuspense(<CreateShipment />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment_edit(),
							element: withSuspense(<EditShipment edit />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment_plans(),
							element: withSuspense(<FulfillmentPlans />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment_plan_create(),
							element: withSuspense(<CreateFulfillment />),
						},
						{
							path: paths.admin_manage_enquiry_order_edit_fulfillment_plan_edit(),
							element: withSuspense(<EditFulfillment />),
						},
					],
				},
				{
					path: paths.admin_manage_enquiry_orders_order_book,
					element: withSuspense(<AdminOrdersOrderBook />),
				},

				{
					path: '*',
					element: <Navigate to={paths.admin_manage_enquiry_order_status('active')} />,
				},
			],
		},

		{
			path: paths.routePath(paths.admin_manage_auction_orders, paths.admin),
			element: withSuspense(<AdminAuctionOrders />),
			title: strings('manage_auction_orders'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_manage_auction_order_status('active')} /> },
				{
					path: paths.admin_manage_auction_order_status(),
					element: withSuspense(<AdminAuctionOrdersByStatus isAuction />),
				},
				{
					path: paths.admin_manage_auction_order_edit(),
					element: withSuspense(<AdminManageAuctionOrder />),
				},
				{
					path: '*',
					element: <Navigate to={paths.admin_manage_auction_order_status('active')} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_payment_summary, paths.admin),
			element: withSuspense(<AdminPaymentSummary />),
			title: strings('ledgers'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_ledger} /> },
				{
					path: paths.admin_ledger,
					element: withSuspense(<Ledgers />),
				},
				{
					path: paths.admin_sale_invoices,
					element: withSuspense(<SaleInvoices />),
				},
				{
					path: paths.admin_purchase_invoices,
					element: withSuspense(<PurchaseInvoices />),
				},
				{
					path: paths.admin_past_record,
					element: withSuspense(<PastRecords isAdmin />),
				},
				{
					path: paths.admin_due_payments,
					element: withSuspense(<DuePayments />),
				},
				{
					path: paths.admin_advance_to_supplier,
					element: withSuspense(<DuePayments />),
				},
				{
					path: paths.admin_collections,
					element: withSuspense(<Collections />),
				},
				{
					path: paths.admin_payment,
					element: withSuspense(<Payment />),
				},
				{
					path: '*',
					element: <Navigate to={paths.admin_ledger} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_list_inventory, paths.admin),
			element: withSuspense(<Inventory selected={0} />),
			title: strings('supplier_by_inventory'),
		},
		{
			path: paths.routePath(paths.admin_add_inventory, paths.admin),
			element: withSuspense(<Inventory selected={1} />),
			title: strings('supplier_by_inventory'),
		},
		{
			path: paths.routePath(paths.admin_bid_auction, paths.admin),
			element: <AdminAuction />,
			children: [
				{ index: true, element: <Navigate to={paths.admin_create_auction} /> },
				{ path: paths.admin_create_auction, element: withSuspense(<AdminCreateAuction />), title: strings('create_auction') },
				{
					path: paths.admin_manage_auction,
					element: withSuspense(<AdminManageAuctions />),
					title: strings('manage_auctions'),
					children: [
						{ index: true, element: <Navigate to={paths.admin_manage_auction_all} /> },
						{ path: paths.admin_manage_auction_assign, element: withSuspense(<AdminAssignAuction status={auctionStatus.created} />) },
						{ path: paths.admin_manage_auction_all, element: withSuspense(<AdminAllAuctions />) },
						{ path: paths.admin_manage_auction_verify, element: withSuspense(<AdminVerifyAuction status={auctionStatus.unverified} />) },
						{ path: paths.admin_manage_auction_active, element: withSuspense(<AdminActiveAuctions status={auctionStatus.active} />) },
						{ path: paths.admin_manage_auction_my, element: withSuspense(<AdminMyAuctions />) },
						{ path: paths.admin_manage_auction_edit(), element: withSuspense(<AdminEditAuction />) },
						{ path: paths.admin_manage_auction_view(), element: withSuspense(<AdminViewAuction />) },
						{ path: paths.admin_manage_auction_manage(), element: withSuspense(<AdminManageAuction />) },
						{
							path: '*',
							element: <Navigate to={paths.admin_manage_auction_all} />,
						},
					],
				},
				{
					path: '*',
					element: <Navigate to={paths.admin} />,
				},
			],
		},
		{
			// routes are changed, now we are using new folder called logistics quote instead of logistics and that will be removed
			// in future. For now it is just 3 lists
			path: paths.routePath(paths.admin_logistics, paths.admin),
			element: withSuspense(<AdminLogisticsQuote />),
			title: strings('logistics'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_logistics_quote_all} /> },
				{ path: paths.admin_logistics_quote_all, element: withSuspense(<AdminLogisticsList />) },
				{ path: paths.admin_logistics_quote_active, element: withSuspense(<AdminLogisticsList status={'ACTIVE'} />) },
				{
					path: paths.admin_logistics_quote_order_placed,
					element: withSuspense(<AdminLogisticsList status={'ORDER_PLACED'} />),
				},
				{ path: paths.admin_logistics_price, element: withSuspense(<LogisticsPrices />) },
				// { path: paths.admin_create_logistics_quote, element: withSuspense(<CreateAdminLogisticsQuote />) },
			],
		},
		{
			path: paths.routePath(paths.admin_cloud_factory, paths.admin),
			element: withSuspense(<AdminCloudFactory />),
			title: strings('cloud_factory'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_cloud_factories} /> },
				{ path: paths.admin_cloud_factories, element: withSuspense(<AdminListFactories />) },
				{ path: paths.admin_cloud_machines, element: withSuspense(<AdminListMachines />) },
				{ path: paths.admin_add_factory, element: withSuspense(<AdminCreateFactory />) },
				{ path: paths.admin_add_machine_template, element: withSuspense(<AdminCreateMachine />) },
				{ path: paths.admin_cloud_edit_machine(), element: withSuspense(<AdminEditMachine />) },
				{ path: paths.admin_cloud_edit_factory(), element: withSuspense(<AdminEditFactory />) },
				{ path: paths.admin_cloud_orders, element: withSuspense(<AdminListFactoryOrders />) },
				{ path: paths.admin_cloud_factory_create_order, element: withSuspense(<AdminCreateFactoryOrder />) },
				{ path: paths.admin_cloud_factory_manage_order(), element: withSuspense(<AdminManageCloudOrder />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_cloud_factories} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_tools, paths.admin),
			element: <AdminTools />,
			title: strings('tools'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_tools_all} /> },
				{ path: paths.admin_tools_all, element: withSuspense(<AdminAllTools />) },
				{ path: paths.admin_tools_endorsement, element: withSuspense(<AdminEndorsement />) },
				{ path: paths.admin_tools_invoice_endorsement, element: withSuspense(<AdminInvoiceEndorsement />) },
				{ path: paths.admin_tools_logistics_calculator, element: withSuspense(<AdminLogisticCalculator />) },
				{ path: paths.admin_tools_distance_calculator, element: withSuspense(<AdminDistanceCalculator />) },
				{ path: paths.admin_tools_vernacularize, element: withSuspense(<AdminVernacularize />) },
				{ path: paths.admin_tools_ifc, element: withSuspense(<AdminToolsIFC />) },
				{ path: paths.admin_weight_calculator, element: withSuspense(<WeightCalculator />) },
				{ path: paths.admin_tools_data_correction, element: withSuspense(<DataCorrection />) },
				{ path: paths.admin_tools_fetch_from_probe, element: withSuspense(<FetchFromProbeTool />) },
				{ path: paths.admin_tools_po_invoice_mapping, element: withSuspense(<PoInvoiceMapping />) },
				{ path: paths.admin_tools_reconciliation_process, element: withSuspense(<ReconciliationProcess />) },
				{ path: paths.admin_tools_upload_dashboard_report, element: withSuspense(<UploadDashboardReport />) },

				{
					path: '*',
					element: <Navigate to={paths.admin_tools} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_content, paths.admin),
			element: <AdminContent />,
			title: strings('content'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_content_all} /> },
				{ path: paths.admin_content_all, element: withSuspense(<AdminAllContent />) },
				{ path: paths.admin_content_banner, element: withSuspense(<AdminBanner />) },
				{ path: paths.admin_content_blog, element: withSuspense(<Blog />) },
				{ path: paths.admin_content_blog_create, element: withSuspense(<CreateBlog />) },
				{ path: paths.admin_content_blog_edit(), element: withSuspense(<CreateBlog />) },
				{ path: paths.admin_content_news, element: withSuspense(<News />) },
				{ path: paths.admin_content_glossary, element: withSuspense(<Glossary />) },
				{ path: paths.admin_content_glossary_create, element: withSuspense(<AddGlossary />) },
				{ path: paths.admin_content_glossary_edit(), element: withSuspense(<AddGlossary />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_content} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_reports, paths.admin),
			element: <AdminReports />,
			title: strings('reports'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_reports_all} /> },
				{ path: paths.admin_reports_all, element: withSuspense(<AdminAllReports />) },
				{ path: paths.admin_view_report(), element: withSuspense(<ViewReport />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_reports} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_approval_metrics, paths.admin),
			element: withSuspense(<ApprovalMetrics />),
			title: strings('approvals'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_approval_metrics_pending} /> },
				{ path: paths.admin_approval_metrics_all_actions, element: withSuspense(<ListApprovalMetrics />) },
				{ path: paths.admin_approval_metrics_approved, element: withSuspense(<ListApprovalMetrics />) },
				{ path: paths.admin_approval_metrics_declined, element: withSuspense(<ListApprovalMetrics />) },
				{ path: paths.admin_approval_metrics_pending, element: withSuspense(<ListApprovalMetrics />) },
				{ path: paths.admin_approval_metrics_history, element: withSuspense(<ListApprovalMetrics />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_approval_metrics_pending} />,
				},
			],
		},
		{
			path: paths.routePath(paths.admin_commodity_prices, paths.admin),
			element: withSuspense(<CommodityPrices />),
			title: strings('commodity', 'prices'),
		},
		{
			path: paths.routePath(paths.admin_bills, paths.admin),
			element: withSuspense(<AdminInvoice />),
			title: strings('bills'),
		},
		{
			path: paths.routePath(paths.admin_underwriting, paths.admin),
			element: <AdminUnderwriting />,
			title: strings('underwriting'),
			children: [
				// Sidebar "Underwriting" (/admin/underwriting) now renders the revamped listing,
				// a pathless layout that keeps its three tabs at /admin/underwriting/*.
				{
					element: withSuspense(<UnderwritingV2 />),
					children: [
						{ index: true, element: <Navigate to={paths.admin_underwriting_inspection_reports} replace /> },
						{
							path: paths.admin_underwriting_inspection_reports,
							element: withSuspense(<UnderwritingV2Inspection />),
							title: strings('inspection', 'reports'),
						},
						{
							path: paths.admin_underwriting_financial_reports,
							element: withSuspense(<UnderwritingV2Financial />),
							title: strings('financial', 'reports'),
						},
						{
							path: paths.admin_underwriting_cran_reports,
							element: withSuspense(<UnderwritingV2Cran />),
							title: strings('cran'),
						},
					],
				},
				{
					path: paths.admin_underwriting_all,
					element: withSuspense(<AllUnderwriting />),
					children: [
						{ index: true, element: <Navigate to={paths.admin_underwriting_cran} /> },
						{
							path: paths.admin_underwriting_cran,
							element: withSuspense(<UnderwritingCranList />),
						},
						{
							path: '*',
							element: <Navigate to={paths.admin_underwriting_cran} />,
						},
					],
				},
				{ path: paths.admin_underwriting_view, element: withSuspense(<ViewUnderwritingReport />), title: strings('view', 'underwriting') },
				{
					path: '*',
					element: <Navigate to={paths.admin_underwriting} />,
				},
			],
		},
		{
			path: paths.routePath(paths.mbDocuments, ''),
			element: withSuspense(<MBDocuments />),
		},
		{
			path: paths.routePath(paths.sale_admin_collections, paths.admin),
			element: withSuspense(<SaleCollections />),
			title: strings('collections'),
		},
		{
			path: paths.routePath(paths.admin_dispatch_plan_create, paths.admin),
			element: withSuspense(<AddDispatchPlanV2 />),
			title: strings('add_dispatch_plan'),
		},
		{
			path: paths.routePath(paths.admin_dispatch_plan, paths.admin),
			element: withSuspense(<DispatchPlan />),
			title: strings('dispatch_plan'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_dispatch_plan_all} /> },
				{ path: paths.admin_dispatch_plan_reports, element: withSuspense(<ReportsList />) },
				{
					path: paths.admin_dispatch_plan_active,
					element: withSuspense(<DispatchPlanList />),
				},
				{ path: paths.admin_dispatch_plan_all, element: withSuspense(<AllDispatchPlans />) },
				{ path: paths.admin_dispatch_plan_shipment, element: withSuspense(<ShipmentList />) },
				{ path: paths.admin_dispatch_plan_fulfillment, element: withSuspense(<FulfillmentList />) },
				{
					path: '*',
					element: <Navigate to={paths.admin_dispatch_plan_all} />,
				},
			],
		},
		{
			path: paths.routePath(paths.tenderbook, paths.admin),
			element: <Tenderbook />,
			children: [
				{ index: true, element: <Navigate to={paths.tenderbook_user_list} /> },
				{
					path: paths.tenderbook_user_list,
					element: withSuspense(<TenderbookUserList />),
					title: strings('users'),
				},
				{
					path: paths.tenderbook_leads_list,
					element: withSuspense(<TenderBookLeadsList />),
					title: strings('leads', 'list'),
				},
				{
					path: paths.tenderbook_tender_master,
					element: withSuspense(<TenderMaster />),
					title: strings('tender_master'),
				},
				{ path: paths.tenderbook_tender_bidder_search, element: withSuspense(<TenderBidderSearch />), title: strings('companies') },
				{
					path: '*',
					element: <Navigate to={paths.tenderbook_user_list} />,
				},
			],
		},
		{
			path: paths.routePath(paths.tenderbook_user(), paths.admin),
			element: withSuspense(<TenderbookUserDetails />),
			children: [
				{
					path: paths.tenderbook_user_basic_details(),
					element: withSuspense(<TenderbookUserBasicDetails />),
				},
				{
					path: paths.tenderbook_user_overview(),
					element: withSuspense(<TenderbookUserOverview />),
				},
				{
					path: paths.tenderbook_user_subscription(),
					element: withSuspense(<TenderbookUserSubscription />),
				},
				{
					path: paths.tenderbook_user_tender_activity(),
					element: withSuspense(<TenderbookUserTenderActivity />),
				},
				{
					path: paths.tenderbook_user_searches(),
					element: withSuspense(<TenderbookUserSearches />),
				},
			],
		},
		{
			path: paths.routePath(paths.admin_lead, paths.admin),
			element: withSuspense(<Lead />),
			title: strings('leads'),
			children: [
				{ index: true, element: <Navigate to={paths.admin_lead_all} /> },
				{ path: paths.admin_lead_all, element: withSuspense(<LeadListAll />) },

				{
					path: paths.admin_manage_lead,
					element: withSuspense(<ManageLead />),
					title: strings('manage_lead'),
					children: [
						{ index: true, element: <Navigate to={paths.admin_lead_details} /> },
						{ path: paths.admin_lead_details(), element: withSuspense(<LeadDetails />) },
						{ path: paths.admin_lead_details_edit(), element: withSuspense(<EditLeadDetails />) },
						{ path: paths.admin_lead_inspection_lead_list(), element: withSuspense(<InspectionLeadList />) },
						{ path: paths.admin_lead_inspection_lead_add(), element: withSuspense(<InspectionLead />) },
						{ path: paths.admin_lead_inspection_lead_new(), element: withSuspense(<NewInspectionLead />) },
						{ path: paths.admin_lead_inspection_lead_edit(), element: withSuspense(<InspectionLead />) },
						{ path: paths.admin_lead_Journey(), element: withSuspense(<JourneyLead />) },
						{ path: paths.admin_lead_Meetings(), element: withSuspense(<MeetingsLead />) },
						{ path: paths.admin_lead_notes(), element: withSuspense(<NotesLead />) },
						{ path: paths.admin_lead_task_reminder(), element: withSuspense(<TaskReminderLead />) },

						{
							path: '*',
							element: <Navigate to={paths.admin_lead_all} />,
						},
					],
				},
			],
		},
		{
			path: '*',
			element: <Navigate to={paths.admin} />,
		},
	],
}

export default AdminRoutes
